import { LeftOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import '../../index.scss';
import React, { useEffect, useRef, useState } from "react";
import { Button, Divider, Empty, Input, InputNumber, Radio, Select, Space, Spin, message, Checkbox } from "antd";
import DocumentsList from "../../components/DocumentsList/DocumentsList";
import { createQuiz, getQuizTheme } from "../../requests";
import { getDocumentListByTheme, getQuestionListByTheme } from "../../requests/theme";
import QuestionList from "../../components/QuestionList/QuestionList";
import { checkPageFormat, getSelectedDocumentIds } from "../../tools";

const {TextArea} = Input;
const CheckboxGroup = Checkbox.Group;

{/* <Radio value={1}>Single Choice</Radio>
<Radio value={2}>Multiple Choice</Radio>
<Radio value={3}>Q&A</Radio> */}

const quizTypeOptions = [
    {value: 1, label: 'Single Choice'},
    {value: 2, label: 'Multiple Choice'},
    {value: 3, label: 'Q&A'},
]

function TestGenerator (props){

    const navigate = useNavigate();

    const [documentsList, setDocumentsList] = useState([]);
    const [theme, setTheme] = useState(null);
    const [items, setItems] = useState([]);
    const [quizType, setQuizType] = useState([]);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();
    const [showSpin, setShowSpin] = useState(false);
    const [questionList, setQuestionList] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));
    const [questionNumber, setQuestionNumber] = useState(null);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [questionNumberType, setQuestionNumberType] = useState(null);
    const [reRender, setReRender] = useState(false);
    const totalQuestionListRef = useRef([]);

    useEffect(()=>{
        const func = async ()=>{
            const items = await getQuizTheme(user.user_id);
            setItems(items.themeList)
        }
        try{
            func();
        }catch(err){
            console.log(err);
        }
    }, [])

    useEffect(()=>{
        if(quizType.length !== 0){
            const newQl = questionList.filter(ele=>{
                if(quizType.indexOf(ele.type) > -1){
                    return true;
                }
                }
            );
            setQuestionList(newQl);
            setReRender(!reRender);
        }
    }, [documentsList, theme])

    useEffect(()=>{
        const selectedDL = documentsList.filter(ele=>ele.selected).map(ele=>ele.document_id);
        let tempQL = totalQuestionListRef.current.filter(ele=>selectedDL.indexOf(ele.document_id) > -1);
        if(quizType.length !== 0){
            tempQL = tempQL.filter(ele=>quizType.indexOf(ele.type) > -1);
        }
        setQuestionList(tempQL);
        setReRender(!reRender);
    }, [quizType])

    const handleLeftOutClick = ()=>{
        navigate('/quiz-set');
    }

    const handleClickFile = (file)=>{
        const newDL = documentsList.slice();
        newDL.forEach(element => {
            if(element.document_id === file.document_id){
                element.selected = !file.selected;
            }
        });
        const selectedDL = getSelectedDocumentIds(newDL);
        const tempQL = totalQuestionListRef.current.filter(ele=>selectedDL.indexOf(ele.document_id) > -1);
        setQuestionList(tempQL);
        setDocumentsList(newDL);
    }


    const handleThemeChange = async (itemValue)=>{
        const docList = await getDocumentListByTheme(itemValue);
        const quesList = await getQuestionListByTheme(itemValue);
        setTheme(itemValue);
        setDocumentsList(docList);
        setQuestionList(quesList);
        totalQuestionListRef.current = quesList;
    }

    const handleQTChange = (v)=>{

        setQuizType(v);
    }

    const handleQuesNumTypeChange = (v)=>{
        setQuestionNumberType(v);
        if(v === 1){
            setQuestionNumber(questionList.length);
        }else{
            setQuestionNumber(null);
        }
    }

    const handleSubmit = async ()=>{
        let fileList;
        fileList = documentsList.filter((ele)=>
            ele.selected === true
        )
        if(!theme){
            messageApi.error('Please select theme');
            return;
        }
        if(fileList.length === 0){
            messageApi.error('Please select file');
            return;
        }
        if(!quizType || quizType.length === 0){
            messageApi.error('Please select quiz type');
            return;
        }
        if(!questionNumber){
            messageApi.error('Please enter question number');
            return;
        }
        if(!title){
            messageApi.error('Please enter title');
            return;
        }
        let nums;
        if(questionNumberType === 3){
            try{
                nums = checkPageFormat(questionNumber);
                for(let i = 0; i < nums; i ++){
                    if(nums[i] > questionList.length){
                        throw new Error('Exceed question range');
                    } 
                }
            }catch(err){
                messageApi.error(err.message || 'Question number format error');
                return;
            }
        }


        // if(!description){
        //     messageApi.error('Please enter description');
        //     return;
        // }
        let qn;
        switch(questionNumberType){
            case 1:{
                qn = questionList.map(ele=>ele.question_id);
                break;
            }
            case 2:{
                if(questionList.length <= questionNumber){
                    qn = questionList.map(ele=>ele.question_id);
                }else{
                    qn = new Set();
                    while(qn.size < questionNumber){
                        const index = Math.floor(Math.random() * questionList.length); 
                        qn.add(questionList[index].question_id)
                        questionList.splice(index, 1);
                    }
                    qn = Array.from(qn);
                }
                break;
            }
            case 3:{
                qn = [];
                for(let i = 0; i < nums.length; i ++){
                    qn.push(questionList[nums[i] - 1].question_id)
                }
                break;
            }
        }
        const obj = {
            user_id: user.user_id,
            theme: theme,
            document_ids: fileList.map(ele=>ele.document_id),
            type: questionNumberType,
            // type = 1, all questions within those documents
            // type = 2, total question numbers
            // type = 3, list of question ids
            question_number: qn,
            title: title,
            description: description,
        }
        try{
            messageApi.info('Creating quiz... will prompt you when creation is complete.');
            setShowSpin(true);
            setSubmitDisabled(true);
            const ql = await createQuiz(obj);
            setSubmitDisabled(false);
            setShowSpin(false);
            if(ql.length === 0){
                messageApi.error('Generate quiz failed, please retry.');
                return;
            }
            // setQuestionList(ql);
            // setTotal(ql.length);
            await messageApi.open({
                type: 'success',
                content: 'Create quiz success, go to quiz set.',
                duration: 3,
            });
            navigate('/quiz-set');
        }catch(err){
            messageApi.error(err.message);
        }
    }

    return (
        <div className='my-menu-container'>
            {contextHolder}
            <div className="container mt-5 d-flex justify-content-between">
                <LeftOutlined onClick={handleLeftOutClick} style={{transform: 'scale(1.5)'}}/>
                <span className="fs-5 fw-bold">Test Generator</span>
                <span/>
            </div>
            <div className='my-masking-layer'>
                <div className='my-content-container'>
                    {showSpin && <div className="d-flex justify-content-center mt-5">
                        <Spin spinning={showSpin}/> 
                    </div>}
                    <Space direction="vertical" style={{width: '100%'}}>
                    <span className="fs-5 fw-bold">Select Theme</span>
                    <Select
                        style={{
                            width: '100%',
                        }}
                        allowClear
                        className="my-ant-input"
                        placeholder="Select quiz theme"
                        onChange={(item)=>{handleThemeChange(item)}}
                        value={theme}
                        options={items.map((item) => ({
                            label: item.theme_name,
                            value: item.theme_id,
                        }))}
                    />
                    <span className="fs-5 fw-bold">Select Documents</span>
                    {
                        documentsList.length !== 0 ? 
                        <>
                            <DocumentsList documentsList={documentsList} handleClickFile={handleClickFile}/>
                            {/* <div>Questions in question bank: {}</div> */}
                            <Space direction="vertical" style={{width: '100%'}}>
                                <span className="fs-5 fw-bold">Question List</span>
                                <QuestionList key={theme + '' + getSelectedDocumentIds(documentsList).length + '' + quizType.toString() + '' + reRender} questionList={questionList} setQuestionList={setQuestionList} defaultPageSize={5} />
                            </Space>

                            <Space direction="vertical" style={{width: '100%'}}>
                                <span className="fs-5 fw-bold">Select Quiz Type</span>
                                <CheckboxGroup onChange={handleQTChange}  options={quizTypeOptions} />
                            </Space>

                            <div className='quiz-content-container'>
                                <Space direction="vertical" style={{width: '100%'}}>

                                    <span className="fs-5 fw-bold">Select Questions</span>
                                    <Select
                                        style={{ width: '100%' }}
                                        onChange={handleQuesNumTypeChange}
                                        value={questionNumberType}
                                        options={[
                                            { value: 1, label: 'All questions' },
                                            { value: 2, label: 'Random Questions' },
                                            { value: 3, label: 'Input Question Numbers' },
                                        ]}
                                    />
                                    {
                                        questionNumberType === 2 ? <>
                                            <InputNumber placeholder='Number of questions created' style={{width: '100%'}} value={questionNumber} min={0} max={questionList.length} onChange={setQuestionNumber}/>
                                        </> : null
                                    }
                                    {
                                        questionNumberType === 3 ? <>
                                            <Input placeholder='eg. 1,3-6,13' style={{width: '100%'}} value={questionNumber} onChange={e=>setQuestionNumber(e.target.value)}/>
                                        </> : null
                                    }
                                </Space>
                            </div>

                            <span className="fs-5 fw-bold">Title</span>
                            <Input
                                value={title}
                                placeholder="Create a title for the quiz"
                                maxLength={50}
                                onChange={(e)=>setTitle(e.target.value)}
                                className="my-ant-input" />

                            <span className="fs-5 fw-bold">Description</span>
                            <TextArea value={description} placeholder="Briefly describe the quiz..." maxLength={200} onChange={(e)=>setDescription(e.target.value)} className="my-ant-textraea"/>

                            <div className="d-flex justify-content-center mt-3">
                                <Button type="primary" disabled={submitDisabled} onClick={handleSubmit}>Create Quiz</Button>
                            </div>

                        </>
                        :
                        <div className='container d-flex justify-content-center align-items-center'>
                            <Empty
                                description={<span>No files available</span>}
                            />
                        </div>
                    }
                    </Space>
                </div>
            </div>
        </div>
    );

}


export default TestGenerator;
